import React, { useState, useRef, useEffect } from 'react';
import '../../../styles/profilepage.css';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { MdModeEdit } from 'react-icons/md';
import {
  IoSettingsOutline,
  IoToggleOutline,
  IoChevronDown,
} from 'react-icons/io5';
import { MdOutlineMonitor } from 'react-icons/md';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import profilelogo from '../../../assets/icons/logo.png';
import logo from '../../../assets/icons/NewLogo.png';
import logoutIcon from '../../../assets/icons/logout.svg';
import TermsIcon from '../../../assets/icons/terms.svg';
import PrivacyIcon from '../../../assets/icons/privacy.svg';
import HelpIcon from '../../../assets/icons/help.svg';
import ArchiveIcon from '../../../assets/icons/archive.svg';
import { PatientServices } from '../services/PatientServices';
import { AuthServices } from '../../auth/services/AuthServices';
import { handleShare } from "./share"; // import your share function

function ProfilePage() {
  const [theme, setTheme] = useState('System');
  const navigate = useNavigate();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [rating, setRating] = useState(5);
  const [feedbackText, setFeedbackText] = useState('');
  const [isEditingName, setIsEditingName] = useState(false);
  const [profilePictureHost, setProfilePictureHost] = useState('');
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser
      ? JSON.parse(storedUser)
      : { email: '', id: '', name: '', photo: '' };
  });
  const [editedName, setEditedName] = useState(user.name || '');
  const fileInputRef = useRef(null);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('profilePhoto', file, user.id + file.name);

    const response = await PatientServices.updatePhoto(formData);

    if (response.status !== 200) {
      console.log('There was an error uploading your image. Please try again.');
      return;
    }

    const updatedUser = {
      ...user,
      profile_picture: response?.data?.data?.imageUrl,
    };
    setUser(updatedUser);
  };

  const handleNameSave = () => {
    const updatedUser = { ...user, name: editedName };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
    PatientServices.UpdateUserName(updatedUser);
    setIsEditingName(false);
  };

  const handleLogout = () => {
    setShowFeedbackModal(true);
  };

  const handleSubmitFeedback = async (rating, feedbackText) => {
    const feedback = { rating, text: feedbackText };
    try {
      const response = await PatientServices.submitFeedback(
        rating,
        feedbackText
      );
      if (response.status !== 200) {
        console.error('Failed to submit feedback:', response);
        return;
      }
      navigate('/login');
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  const fetchUserData = async () => {
    const response = await AuthServices.fetchUserData();
    console.log(response);
  };

  const handleBack = () => navigate(-1);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  useEffect(() => {
    if (user?.profile_picture) {
      const url = `${user?.profile_picture.split('images/')[1]}`;
      setProfilePictureHost(url);
    }
  }, [user]);

  useEffect(() => {
    if (!localStorage.getItem('user')) {
      fetchUserData();
    }
  }, []);

  useEffect(() => {
    if (showFeedbackModal) {
      setRating(5);
    }
  }, [showFeedbackModal]);
  return (
    <div className="profile-container">
      <div className="flat-header">
        <button className="back-button" onClick={handleBack}>
          <IoIosArrowBack size={18} />
        </button>
        <img src={logo} alt="PrashaSync Logo" className="archived-logo" />
      </div>

      <div
        className="profile-image-wrapper"
        onClick={() => fileInputRef.current.click()}
      >
        <img
          src={
            user?.profile_picture?.trim()
              ? `${process.env.REACT_APP_IMAGE_UPLOAD_FOLDER}/${profilePictureHost}`
              : profilelogo
          }
          alt="Profile"
          className="profile-image"
          style={{
            filter: user?.photo?.trim(),
          }}
        />
        <div className="edit-icon-avatar">
          <MdModeEdit size={16} />
        </div>
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleImageUpload}
        />
      </div>

      <div className="profile-content">
        <div className="name-row">
          <h2 className="name">
            {user?.first_name + ' ' + user.last_name || (
              <span className="placeholder-text">Enter your name</span>
            )}
          </h2>
          <div
            className="edit-icon-name"
            onClick={() => setIsEditingName(true)}
          >
            <MdModeEdit size={16} />
          </div>
        </div>
        <p className="email">{user.email}</p>

        <div className="appearance-box">
          <div className="appearance-label">
            <IoToggleOutline size={20} />
            <span>Appearance</span>
          </div>
          <div className="appearance-dropdown">
            <MdOutlineMonitor size={18} />
            <select
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
              className="custom-select"
            >
              <option value="System">System</option>
              <option value="Light">Light</option>
              <option value="Dark">Dark</option>
            </select>
            <IoChevronDown size={16} />
          </div>
        </div>

        <div className="settings-box">
          <div className="settings-title">
            <IoSettingsOutline size={16} />
            <span>Settings</span>
          </div>

          <div
            className="setting-item"
            onClick={() =>
              window.open(
                'https://prashauploadimages.blob.core.windows.net/docs/PraSha%20Sync%20terms%20of%20use.pdf ',
                '_blank'
              )
            }
          >
            <div className="setting-left">
              <img src={TermsIcon} alt="Terms" className="setting-icon" />
              <span>Terms of Use</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          <div
            className="setting-item"
            onClick={() =>
              window.open(
                'https://prashauploadimages.blob.core.windows.net/docs/PraShaSync%20privacy%20policy.pdf ',
                '_blank'
              )
            }
          >
            <div className="setting-left">
              <img src={PrivacyIcon} alt="Privacy" className="setting-icon" />
              <span>Privacy Policy</span>
            </div>
            <BsBoxArrowUpRight />
          </div>

          <div className="setting-item" onClick={() => navigate('/archive')}>
            <div className="setting-left">
              <img src={ArchiveIcon} alt="Archive" className="setting-icon" />
              <span>Archive</span>
            </div>
            <IoIosArrowForward size={18} />
          </div>

          <div className="setting-item" onClick={() => navigate('/help')}>
            <div className="setting-left">
              <img src={HelpIcon} alt="Help" className="setting-icon" />
              <span>Help</span>
            </div>
            <IoIosArrowForward size={18} />
          </div>
          <div className="setting-item"
            onClick={() => window.open('https://findahelpline.com ', '_blank')}
          // onClick={() => navigate('/help')}
          >
            <div className="setting-left">
              <img src={TermsIcon} alt="Help" className="setting-icon" />
              <span>Find a helpline </span>
            </div>
            <BsBoxArrowUpRight />
          </div>
          <div className="setting-item" onClick={handleShare}>
            <div className="setting-left">
              <img src={TermsIcon} alt="Help" className="setting-icon" />
              <span>Share PraSha Sync</span>
              
            </div>
            {/* <BsBoxArrowUpRight /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z" />
              <path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708z" />
            </svg>
          </div>
        </div>


        <div className="logout-row">
          <button className="logout-button" onClick={handleLogout}>
            Log out{' '}
            <img src={logoutIcon} alt="Logout" className="logout-icon" />
          </button>
        </div>
      </div>

      {isEditingName && (
        <div className="edit-name-modal">
          <div className="modal-content">
            <div className="modal-bar"></div>
            <h4>Edit your name</h4>
            <input
              type="text"
              className="name-input"
              placeholder="Ex. John Mathew"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
            />
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setIsEditingName(false)}
              >
                Cancel
              </button>
              <button
                className="done-btn"
                onClick={handleNameSave}
                disabled={!editedName.trim()}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Feedback Modal */}
      {showFeedbackModal && (
        <div
          className="feedback-modal-overlay"
          onClick={() => setShowFeedbackModal(false)}
        >
          <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
            {submitted ? (
              <>
                <button
                  className="feedback-close-btn"
                  onClick={() => setShowFeedbackModal(false)}
                >
                  ✖
                </button>
                <div className="thank-you-message">
                  <h3 style={{ fontSize: '18px', color: '#000' }}>
                    Thank you for your feedback!
                  </h3>
                </div>
              </>
            ) : (
              <>
                <button
                  className="feedback-close-btn"
                  onClick={() => setShowFeedbackModal(false)}
                >
                  ✖
                </button>
                <div className="emoji">
                  {['🤔', '😞', '😐', '😐', '😄', '😍'][rating] || '🤔'}
                </div>
                <div className="stars-row">
                  {[1, 2, 3, 4, 5].map((val) => (
                    <span
                      key={val}
                      className={`star ${val <= rating ? 'filled' : ''}`}
                      onClick={() => setRating(val)}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <h3>Tell Us</h3>
                <p>
                  {rating >= 4
                    ? 'We’re thrilled to hear that!'
                    : rating > 0
                      ? 'We’re sorry the experience didn’t meet your expectations.'
                      : 'How was your experience?'}
                </p>
                <p className="prompt">
                  {rating >= 4
                    ? 'What did you enjoy the most, and is there anything we can do to make your experience even better?'
                    : rating > 0
                      ? 'Could you share what specifically didn’t work for you, and how we can do better next time?'
                      : 'Tap a star and share your thoughts!'}
                </p>
                <textarea
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  placeholder="Type here..."
                  maxLength={500}
                />
                <div className="char-count">{feedbackText.length}/500</div>
                <button
                  className="submit-btn"
                  disabled={rating === 0}
                  onClick={() => {
                    handleSubmitFeedback(rating, feedbackText);
                    setSubmitted(true);
                    setTimeout(() => {
                      setSubmitted(false);
                      setShowFeedbackModal(false);
                      setRating(5);
                      setFeedbackText('');
                      navigate('/');
                    }, 4000);
                  }}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfilePage;
